import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

var $ = jQuery;

$(function () {
	initSwipers();
	setTimeout(matchHeight, 500);
	$(window).on('resize', debounce(matchHeight, 200));
});

function initSwipers() {
	initHeroSwiper();
	initTestimonialSwipers();
	initSimilarArticlesSwiper();
	initNewsCarouselSwiper();
	initGallerySwiper();
	initMediaCarouselSwipers();
	initTeamCarouselSwipers();
}

function initHeroSwiper() {
	const hero = $('.bnr-hero');
	if (!hero.length) return;

	new Swiper(hero.find('.swiper')[0], {
		modules: [Navigation, Pagination, Keyboard],
		loop: false,
		slidesPerView: 1,
		autoHeight: true,
		navigation: {
			nextEl: hero.find('.swiper-button-next')[0],
			prevEl: hero.find('.swiper-button-prev')[0],
		},
		pagination: {
			el: hero.find('.swiper-pagination')[0],
			clickable: true,
		},
		keyboard: { enabled: true }
	});
}

function initTestimonialSwipers() {
	const block = $('.blk-testimonial');
	if (!block.length) return;

	$('.blk-testimonial').each(function () {
		const $block = $(this);
		const numSlider = parseInt($block.attr('data-num'), 10) || 1;

		new Swiper($block.find('.swiper')[0], {
			modules: [Navigation, Pagination, Keyboard],
			loop: true,
			slidesPerView: 1,
			spaceBetween: 16,
			breakpoints: {
				768: { slidesPerView: numSlider > 1 ? 2 : 1, spaceBetween: 16 },
				1024: { slidesPerView: numSlider, spaceBetween: 24 },
			},
			navigation: {
				nextEl: $block.find('.swiper-button-next')[0],
				prevEl: $block.find('.swiper-button-prev')[0],
			},
			keyboard: { enabled: true }
		});
	});
}

function initSimilarArticlesSwiper() {
	const block = $('.blk-similar-articles');
	if (!block.length) return;

	new Swiper(block.find('.swiper')[0], {
		modules: [Navigation, Pagination, Keyboard],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: true,
		breakpoints: {
			768: { slidesPerView: 2, spaceBetween: 16 },
			1024: { slidesPerView: 4, spaceBetween: 24 }
		},
		navigation: {
			nextEl: block.find('.swiper-button-next')[0],
			prevEl: block.find('.swiper-button-prev')[0],
		},
		keyboard: { enabled: true }
	});
}

function initNewsCarouselSwiper() {
	const block = $('.blk-news-carousel');
	if (!block.length) return;

	new Swiper(block.find('.swiper')[0], {
		modules: [Navigation, Pagination, Keyboard],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: true,
		breakpoints: {
			768: { slidesPerView: 2.5, spaceBetween: 16 },
			1024: { slidesPerView: 3.5, spaceBetween: 24 }
		},
		navigation: {
			nextEl: block.find('.swiper-button-next')[0],
			prevEl: block.find('.swiper-button-prev')[0],
		},
		keyboard: { enabled: true }
	});
}

function initGallerySwiper() {
	const $block = $('.blk-gallery');
	if (!$block.length) return;

	const swiperContainer = $block.find('.swiper')[0];
	if (!swiperContainer) return;

	const gallerySwiper = new Swiper(swiperContainer, {
		modules: [Navigation, Pagination, Keyboard],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 16,
		autoHeight: true,
		navigation: {
			nextEl: $block.find('.swiper-button-next')[0],
			prevEl: $block.find('.swiper-button-prev')[0],
		},
		keyboard: { enabled: true }
	});

	const $modal = $('#galleryCarouselModal');
	const modalEl = $modal.get(0);
	const closeBtn = document.getElementById('closeGalleryCarouselModal');

	function openModal(index) {
		gallerySwiper.slideToLoop(index, 0, false);
		$modal.removeClass('hidden').attr('aria-hidden', 'false');
		$('body').addClass('overflow-hidden');
	}

	function closeModal() {
		$modal.addClass('hidden').attr('aria-hidden', 'true');
		$('body').removeClass('overflow-hidden');
	}

	// Use event delegation for scalability
	$block.on('click', '[data-index]', function () {
		const index = parseInt($(this).data('index'), 10);
		if (!isNaN(index)) openModal(index);
	});

	// Close modal events
	closeBtn?.addEventListener('click', closeModal);

	$modal.on('click', function (e) {
		if (e.target === modalEl) closeModal();
	});
}


function initMediaCarouselSwipers() {
	const block = $('.blk-media-carousel');
	if (!block.length) return;
	
	$('.blk-media-carousel').each(function () {
		const $block = $(this);
		const oneImagePerRow = parseInt($block.data("one-image")) === 1;

		new Swiper($block.find(".main-swiper")[0], {
			modules: [Navigation, Pagination, Keyboard],
			loop: true,
			slidesPerView: oneImagePerRow ? 1.2 : 4.5,
			spaceBetween: 16,
			centeredSlides: !oneImagePerRow,
			breakpoints: {
				768: { slidesPerView: oneImagePerRow ? 1.2 : 2.5, spaceBetween: 16 },
				1024: { slidesPerView: oneImagePerRow ? 1.2 : 4.5, spaceBetween: 24 }
			},
			navigation: {
				nextEl: $block.find(".carousel-button-next")[0],
				prevEl: $block.find(".carousel-button-prev")[0]
			},
			keyboard: { enabled: true },
			autoHeight: true
		});

		const $modal = $("#mediaCarouselModal");
		const modalSwiper = new Swiper($modal.find(".modal-swiper")[0], {
			modules: [Navigation],
			loop: true,
			navigation: {
				nextEl: ".modal-button-next",
				prevEl: ".modal-button-prev"
			}
		});

		$block.find(".swiper-slide img").on("click", function () {
			$modal.removeClass("hidden").attr("aria-hidden", "false");
			modalSwiper.slideToLoop(parseInt($(this).data("index")), 0);
			$("body").addClass("overflow-hidden");
		});

		function closeModal() {
			$modal.addClass("hidden").attr("aria-hidden", "true");
			$("body").removeClass("overflow-hidden");
		}

		$modal.on("click", e => {
			if (!$(e.target).closest(".swiper-slide, .swiper-buttons").length) closeModal();
		});
		$("#closeMediaCarouselModal").on("click", closeModal);
	});
}

function initTeamCarouselSwipers() {
	const $blocks = $('.blk-team-carousel');
	if (!$blocks.length) return;

	$blocks.each(function () {
		const $block = $(this);
		const swiperContainer = $block.find('.swiper')[0];
		if (!swiperContainer) return;

		const teamSwiper = new Swiper(swiperContainer, {
			modules: [Navigation, Pagination, Keyboard],
			slidesPerView: 1.2,
			spaceBetween: 16,
			breakpoints: {
				425: { slidesPerView: 2.5, spaceBetween: 16 },
				1200: { slidesPerView: 3.5, spaceBetween: 16 }
			},
			pagination: {
				el: $block.find('.swiper-pagination')[0],
				clickable: true
			},
			scrollbar: {
				el: $block.find('.swiper-scrollbar')[0],
				draggable: true
			},
			navigation: {
				nextEl: $block.find('.swiper-button-next')[0],
				prevEl: $block.find('.swiper-button-prev')[0]
			},
			keyboard: { enabled: true }
		});

		// Modal
		const $modal = $block.find("#team-carousel-modal");
		if (!$modal.length) return;

		const modalEl = $modal.get(0);
		const closeModalBtn = $modal.find(".team-carousel-modal-close")[0];

		$block.find(".swiper-slide").each(function () {
			const $slide = $(this);
			$slide.on("click", function () {
				const image = $slide.data("image");
				const name = $slide.data("name");
				const jobTitle = $slide.data("jobTitle");
				const description = $slide.data("description");
				const socialLinks = $slide.data("socialLinks");

				const $modalImage = $modal.find(".team-carousel-modal-image");
				if (image) {
					$modalImage.attr("src", image).attr("alt", name).show();
				} else {
					$modalImage.hide();
				}

				$modal.find(".team-carousel-modal-name").text(name || "");
				$modal.find(".team-carousel-modal-job-title").text(jobTitle || "");
				$modal.find(".team-carousel-modal-description").html(description || "");
				$modal.find(".team-carousel-modal-social-links").html(socialLinks || "");

				$modal.show().attr("aria-hidden", "false");
				$("body").addClass("overflow-hidden");
			});
		});

		function closeModal() {
			$modal.hide().attr("aria-hidden", "true");
			$("body").removeClass("overflow-hidden");
		}

		$(closeModalBtn).on("click", closeModal);

		// Close modal on background click
		$modal.on("click", function (e) {
			if (e.target === modalEl) closeModal();
		});

		// Close modal on ESC
		$(window).on("keydown", function (e) {
			if (e.key === "Escape") closeModal();
		});
	});
}


function matchHeight() {
	$(".match-height-wrapper").each(function () {
		const elements = $(this).find(".match-height");
		let maxHeight = Math.max(...elements.map(function () { return $(this).outerHeight(); }).get());
		elements.height(maxHeight);
	});
}

// Debounce helper
function debounce(fn, delay) {
	let timer;
	return function () {
		clearTimeout(timer);
		timer = setTimeout(fn, delay);
	};
}
